import { Outlet, Navigate } from 'react-router-dom';


function PrivateRoute({ isAllowed, path="/login" } : any) {
  return isAllowed ? <Outlet /> : <Navigate to={path} replace />
}

export default PrivateRoute;
